import { CreateOrganization } from '@clerk/clerk-react'
import type { ReactNode } from 'react'

import { APP_BASE_PATH } from '@/app.const'

export const OnboardingPage = (): ReactNode => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
    <div className="mb-8 text-center">
      <h1 className="text-3xl font-bold tracking-tight">Welcome to SAAGA Solve</h1>
      <p className="mt-2 text-muted-foreground">Create or join an organization to get started.</p>
    </div>

    <CreateOrganization
      appearance={{
        elements: {
          rootBox: 'mx-auto',
          card: 'shadow-lg',
        },
      }}
      afterCreateOrganizationUrl={`${APP_BASE_PATH}/`}
    />
  </div>
)
